
import React from 'react';
export default function Tabs({ categories, active, onChange }){
  return (<div className='tabs'>
    {categories.map(c=>(
      <button key={c.id} className={`tab ${active===c.id?'active':''}`} onClick={()=>onChange(c.id)}>
        {c.label}
      </button>
    ))}
  </div>);
}
